<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card no-header>
          <div slot="header">Información de la Solicitud de Viaticos</div>
          <b-form>
            <app-personal
              v-if="!personalReadOnly"
              label="Personal"
              :label-cols="labelCols"
              :nombre="personalNombre"
              :valido="personalValido"
              :lista="personalList"
              :msjInvalido="personalInvalidoMsj"
              @validate="validate"
              @updated="personalActualizado">
            </app-personal>  

            <b-form-group
              v-if="personalReadOnly"
              label="Personal"
              label-for="personal"
              :label-cols="labelCols">
              <b-form-input 
                id="personal"
                :value="personalNombre"
                :state="personalValido"
                type="text"
                readonly>
              </b-form-input>
              <b-form-invalid-feedback id="personalReadonlyFeedback">
                {{ personalInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Fecha Solicitud"
              label-for="fechaSolicitud"
              :label-cols="labelCols">
              <b-form-input 
                id="fechaSolicitud"
                v-model.trim="$v.fechaSolicitud.$model"
                :state="fechaSolicitudValida"
                type="date"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="fechaSolicitudFeedback">
                {{ fechaSolicitudInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Importe"
              label-for="importe"
              :label-cols="labelCols">
              <b-form-input 
                id="importe"
                v-model.trim="$v.importe.$model"
                :state="importeValido"
                type="number"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="importeFeedback">
                {{ importeInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Observaciones"
              label-for="observaciones"
              :label-cols="labelCols">
              <b-form-textarea
                id="observaciones"
                v-model.trim="$v.observaciones.$model"
                :state="observacionesValido"
                type="text"
                @blur.native="validate"
                rows="3"
                max-rows="6">
              </b-form-textarea>
              <b-form-invalid-feedback id="observacionesFeedback">
                {{ observacionesInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>

          <div slot="footer" v-if="modal">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Grabar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="close">Cancelar</b-button>
          </div>
        </b-card>

        <b-card header="Presupuestos Internos">
          <b-table 
              small 
              responsive="sm" 
              :busy="tableBusy" 
              class="registro-ordenes"
              :items="presupuestosInternos" 
              :fields="fields">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(importe)="data">
              {{ data.item.importe | moneda }}
            </template>
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item 
                    @click.stop="borrarPresupuestoInterno(data.item)">
                  <i class="fa fa-remove"></i>Borrar Presupuesto</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>

          <div class="add-table-btn">
            <div class="list-add-btn" @click.prevent="agregarPresupuestoInterno">
                <i class="fa fa-plus" aria-hidden="true"></i>
            </div>
          </div>
        </b-card>

      </b-col>
    </b-row>

    <b-modal ref="searchPresupuestoInternoModal" 
        title="Seleccionar Presupuesto Interno"
        header-bg-variant="light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-search-presupuesto
        :soloPresupuestosAbiertos="true"
        :seleccionarOrden="true"
        :seleccionarSubtrabajo="false"
        @presupuestoInternoSeleccionado="presupuestoInternoSeleccionado"
        @cancelaSeleccionPresupuestoInterno="cancelaSeleccionPresupuestoInterno">
      </app-search-presupuesto>  
    </b-modal>

    <app-a-b-m-button
      v-if="!modal"
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import SearchPresupuesto from '../presupuestosinternos/Search.vue';
import ABMButtons from '../shared/abmButtons.vue';
import Personal from '../shared/abmSelect.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import { maxLength, decimal, minValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'viatico/getField',
  mutationType: 'viatico/updateField',
});

export default {
  name: 'ViaticosABM',
  components: {
    appSearchPresupuesto: SearchPresupuesto,
    appABMButton: ABMButtons,
    appPersonal: Personal,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  props: {
    viaticoId: {
      type: Number,
      default: 0,
    },
    modal: {
      type: Boolean,
      default: false
    },
    personalParam: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      /* Validacion de datos */
      noValidar: true,
      fechaSolicitudValida: null,
      fechaSolicitudInvalidaMsj: '',
      personalValido: null,
      personalInvalidoMsj: '',
      importeValido: null,
      importeInvalidoMsj: '',
      observacionesValido: null,
      observacionesInvalidoMsj: '',

      fields: [
        {
          key: 'presupuestoInternoNumero',
          label: 'Nro Presupuesto'
        },
        {
          key: 'presupuestoInterno',
          label: 'Presupuesto Interno',
        },
        {
          key: 'ordenTrabajo',
          label: 'Orden de Trabajo',
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      personel: [],
      personalList: [],

      labelCols: 2,
      alertCountDown: 10, 
      dismissCountDown: 0,
      alertVariant: 'danger',
      alertMsj: '',

      tableBusy: false,

      personalReadOnly: true,
    }
  },
  computed: {
    ...mapFields([
      'id',
      'fechaSolicitud',
      'personal',
      'personalNombre',
      'importe',
      'observaciones',
      'presupuestosInternos'
    ]),
  },
  created() {
    this.personalReadOnly = !this.$store.getters['user/tieneAccesoModulo']('ViaticosSeleccionPersonal');

    let viaticoId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        viaticoId = this.$route.params.id;
      }
    }

    if (this.modal) {
      this.labelCols = 3;
    }

    this.showSpinner();
    this.$store.dispatch('viatico/inicializar', viaticoId)
      .then(() => this.getDatosAdicionales())
      .catch( error => this.showErrorMsj (error))
      .finally(() => this.hideSpinner());

  },
  methods: {
    getDatosAdicionales() {
      const vm = this;

      if (!this.personalReadOnly) {
        this.$store.dispatch('personel/getList', true)
          .then(() => {
            vm.personel = this.$store.getters['personel/list'];
            vm.personalList = this.$store.getters['personel/selectList'];
            
            /* Verificamos si el personal esta incluido en la lista (o esta dado de baja) */
            if (vm.personal) {
              if (vm.personal.id != 0) {
                let personal = vm.personel.find( p => p.id == vm.personal.id ); 
                if (!personal) {
                  let item = {
                    id: vm.personal.id,
                    nombre: vm.personal.nombre
                  }
                  vm.personel.push(item);
                  vm.personalList.push (vm.personalNombre);
                  /* Ordenamos el array de nombres */
                  vm.personalList.sort();
                }
              }
            }
          })
          .catch(() => this.showErrorMsj(new Error('Se produjo un error al recuperar el listado del personal.')));
      }
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar) {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'importe' || validarTodos) {
        if (this.$v.importe.$error) {
          this.importeValido = false;
          if (!this.$v.importe.decimal) {
            this.importeInvalidoMsj = 'El importe de la solicitud debe ser un valor numérico';
          } else if (!this.$v.importe.minValue) {
              this.importeInvalidoMsj = 'El importe de la solicitud no es válido';
          }     
        } else {
          this.importeValido = null;
          this.importeInvalidoMsj = '';
        }
      }
      if (campo == 'observaciones' || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValido = false
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidoMsj = 'Las observaciones solo pueden contener hasta 5000 caracteres.'
          }      
        } else {
          this.observacionesValido = null;
          this.observacionesInvalidoMsj = '';
        }
      }

    },
    save () {
      let save = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      if (!this.personalReadOnly) {
        let personal = null;
        if (this.personalNombre) {
          personal = this.getSelected(this.personel, this.personalNombre);

        }

        this.$store.dispatch('viatico/setPersonal', personal);
      }

      let personalError = true;
      if (this.personal) {
        if (this.personal.id) {
          if (this.personal.id != 0) {
            personalError = false;
          }
        }
      }
      if (personalError) {
        save = false;
        this.personalValido = false;
        if (this.personalReadOnly) {
          this.personalInvalidoMsj = 'No tiene un legajo de personal asociado';
        } else {
          this.personalInvalidoMsj = 'Debe seleccionar el personal correspondiente';
        }
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('viatico/save')
            .then( () => this.showModalMsj ('Los cambios se registraron con éxito.', this.goList, this.goList, 'light'))
            .catch( error => this.showErrorMsj (error))
            .finally(() => this.hideSpinner());
        }
      }
    },
    close() {
      this.$emit('close', false);
    },
    goList() {
      if (this.modal) {
        this.$emit('close', true);
      } else {
        this.$router.push({ name: "Viaticos" });
      }
    },
    personalActualizado(personalNombre) {
      this.personalNombre = personalNombre;
    },
    agregarPresupuestoInterno() {
      this.$refs.searchPresupuestoInternoModal.show()
    },
    presupuestoInternoSeleccionado(params) {
      // console.log(params);
      if (params) {
        this.$refs.searchPresupuestoInternoModal.hide();
        this.$store.dispatch('viatico/addPresupuesto', params)
          .catch(error => this.showErrorMsj(error));
      }
    },
    cancelaSeleccionPresupuestoInterno() {
      this.$refs.searchPresupuestoInternoModal.hide()
    },
    borrarPresupuestoInterno(item) {
      this.$store.dispatch('viatico/removePresupuesto', item.presupuestoInternoId)
        .catch(error => this.showErrorMsj(error));
    }
  },
  /* Vuelidate */
  validations: {
    fechaSolicitud: {},
    importe: {
      decimal,
      minValue: minValue(0)
    },
    observaciones: {
      maxLength: maxLength(5000)
    },
  },  
}
</script>

<style>
</style>